import {
  CircularProgress,
  IconButton,
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { useMutation } from "react-query";
import {
  deleteObeservtaions,
  getObeservtaions,
  viewdocuments,
} from "../../services";
import { useEffect, useState } from "react";
import { Delete, RemoveRedEye } from "@mui/icons-material";
import useViewFiles from "../../../hooks/useView";
import { clinicId } from "../../../constants";

const ObservationPopup = ({ data }: { data: any }) => {
  const { viewFile } = useViewFiles();
  const [selectedIndex, setselectedIndex] = useState(-1);
  const [list, setList] = useState([]);
  const { mutate: getdocs, isLoading: obsListLoading } = useMutation(
    getObeservtaions,
    { onSuccess: (data) => setList(data.response) }
  );
  const { mutate: ViewActivity, isLoading: activityLoading } = useMutation(
    viewdocuments,
    {
      onSuccess: (data) => {
        viewFile(data.response as string);
      },
    }
  );
  const { mutate: deletefile, isLoading: deleteLoading } = useMutation(
    deleteObeservtaions,
    {
      onSuccess(data, variables) {
        if (data.responseIndicator == "success") {
          setList((prev) =>
            prev.filter((item: any) => item.id !== variables.id)
          );
        }
      },
    }
  );

  const viewfile = (id: number) => {
    const body = {
      ...data,
      id,
    };
    ViewActivity(body);
  };

  const deleteDocument = (id: number) => {
    const body = {
      ...data,
      id,
      clinicId,
    };
    deletefile(body);
  };

  useEffect(() => {
    getdocs(data);
  }, []);
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell> Observations </TableCell>
          <TableCell> Actions </TableCell>
        </TableRow>
      </TableHead>
      <CustomTableBody
        alert={"No Observations"}
        totalSpan={{ col: 2, row: 2 }}
        isData={Boolean(list?.length)}
        dataLoading={obsListLoading}
      >
        {list?.map((item: any, index: number) => (
          <>
            <TableRow>
              <TableCell>{item.fileName}</TableCell>
              <TableCell className=" flex gap-x-4">
                <IconButton
                  onClick={() => {
                    viewfile(item?.id), setselectedIndex(index);
                  }}
                  className="pointer"
                >
                  {activityLoading && selectedIndex == index ? (
                    <CircularProgress size={20} />
                  ) : (
                    <RemoveRedEye color="primary" />
                  )}{" "}
                </IconButton>{" "}
                <IconButton
                  onClick={() => {
                    deleteDocument(item?.id), setselectedIndex(index);
                  }}
                >
                  {deleteLoading && selectedIndex == index ? (
                    <CircularProgress size={20} />
                  ) : (
                    <Delete color="error" />
                  )}
                </IconButton>
              </TableCell>
            </TableRow>
          </>
        ))}
      </CustomTableBody>
    </Table>
  );
};

export default ObservationPopup;
